import { FC } from 'react';
import { Image, Skeleton } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import { ScreenLayout } from "../ScreenLayout";
import graph from "../../images/graph.png";
import styles from './index.module.scss'

export const DynamicsScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout
      hiddenTabs
      header={(
        <>
          <div className={styles.title}>
            <LeftOutlined style={{ fontSize: 18, marginRight: 12 }} />
            Динамика
          </div>
        </>
      )}
    >
      <Image
        width={155}
        height={120}
        alt="profile"
        preview={false}
        src={graph}
      />
      <div className={styles.body}>
        <EditableContent type="header" maxLength={90} onSave={onEdit}>
          {data?.header}
        </EditableContent>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
    </ScreenLayout>
  )
}